<template>
    <ServiceLnb v-if="$route.meta.requiresLnb !== false"/>
    <div class="content">
        <ServiceHeader v-if="$route.meta.requiresHeader !== false"/>
        <router-view :key="$route.fullPath"/>
    </div>
</template>

<script>
// 서비스 페이지 전용 컴포넌트 CSS (로그인 이후 화면)
import('@/assets/css/component/header.css');
import('@/assets/css/component/banner.css');
import('@/assets/css/component/button.css');
import('@/assets/css/component/frame.css');
import('@/assets/css/component/footer.css');
import('@/assets/css/component/list.css');
import('@/assets/css/component/menu.css');
import('@/assets/css/component/navigation.css');
import('@/assets/css/component/category.css');
import('@/assets/css/component/progress.css');
import('@/assets/css/component/pagination.css');
import('@/assets/css/component/preview.css');
import('@/assets/css/component/dropdown.css');
import('@/assets/css/component/input.css');
import('@/assets/css/component/tag.css');
import('@/assets/css/component/toggle.css');
import('@/assets/css/component/tost.css');
import('@/assets/css/component/popup.css');
import('@/assets/css/component/snackbar.css');
import('@/assets/css/component/reaction.css');
import('@/assets/css/component/hover-info.css');
import('@/assets/css/component/graph.css');
import('@/assets/css/component/widget.css');
import('@/assets/css/component/sub-content.css');

import ServiceHeader from '@/components/layout/ServiceHeader.vue';
import ServiceLnb from '@/components/layout/ServiceLnb.vue';

export default {
    name: 'ServiceLayout',
    components: {
        ServiceHeader,
        ServiceLnb,
    },
    mounted() {
        //this.$adjustContentWrapperMargin();
    }
};
</script>

<style scoped lang="scss">
</style>
